import type { ReactNode } from 'react';

export const symbol_nightlife: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M261-220v-204L71-714q-10-15-1.5-30.5T96-760h390q18 0 26.5 15.5T511-714L321-424v204h54q13 0 21.5 8.5T405-190q0 13-8.5 21.5T375-160H207q-13 0-21.5-8.5T177-190q0-13 8.5-21.5T207-220h54Zm-61-394h182l55-86H145l55 86Zm352.5 421.5Q520-225 520-275t32.5-82.5Q585-390 635-390q15 0 28.5 3t26.5 8v-351q0-13 8.5-21.5T720-760h111q20 0 34.5 14.5T880-711q0 20-14.5 35T831-661h-81v386q0 50-32.5 82.5T635-160q-50 0-82.5-32.5Z"
		/>
	</svg>
);
